import React, { useEffect, useState } from 'react';
import { useGlobal } from '@rcg/ui-react';
import clsx from 'clsx';
import { Card } from '@material-ui/core';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';

const images = require.context('../../assets/icons/whyChooseUs', true, /\.(png|jpe?g|svg)$/);

const CardMui = ({ extraClass, dictionaryKey, dictionaryDefaultValue, imgPath }) => {
  const [benefitImage, setBenefitImage] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      try {
        const imageImport = await images(imgPath);
        setBenefitImage(imageImport);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading image:', error);
      }
    };

    loadImage();
  }, []);

  const classes = useStyles();
  const { renderContent } = useGlobal();
  return (
    <Card className={clsx(classes.card, extraClass)}>
      <img src={benefitImage} alt="Air benefit icon" />
      <p
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: renderContent(dictionaryKey, dictionaryDefaultValue),
        }}
      />
    </Card>
  );
};

const WhyChooseUsRoyal = () => {
  const classes = useStyles();
  const { renderContent } = useGlobal();

  const tabType = new URLSearchParams(window.location.search).get('booking');
  const { hash } = window.location;

  React.useEffect(() => {
    const section = document.getElementById('whyChooseUs');
    if (hash === '#whyChooseUs' && tabType === 'browse' && section) section.scrollIntoView();
  }, [hash, tabType]);
  return (
    <div className={classes.whyChooseUs} id="whyChooseUs">
      <div className={classes.sectionWrapper}>
        <div className={classes.text}>
          <span>
            {renderContent(
              Dictionary.airFlightBookFlightsWhyChooseUsTitle.key,
              Dictionary.airFlightBookFlightsWhyChooseUsTitle.defaultValue,
            )}
          </span>
          <p
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: renderContent(
                Dictionary.airFlightBookFlightsWhyChooseUsSubTitle.key,
                Dictionary.airFlightBookFlightsWhyChooseUsSubTitle.defaultValue,
              ),
            }}
          />
        </div>
        <div className={classes.cardWrapper}>
          <CardMui
            extraClass={classes.lowestAirfareGuarantee}
            dictionaryKey={Dictionary.airFlightBookFlightsWhyChooseUsLowestAirfareGuaranteeText.key}
            dictionaryDefaultValue={
              Dictionary.airFlightBookFlightsWhyChooseUsLowestAirfareGuaranteeText.defaultValue
            }
            imgPath={renderContent(
              Dictionary.airBookFlightsWhyChooseUsLafImgPath.key,
              Dictionary.airBookFlightsWhyChooseUsLafImgPath.defaultValue,
            )}
          />
          <CardMui
            extraClass={classes.assuredArrival}
            dictionaryKey={Dictionary.airFlightBookFlightsWhyChooseUsAssuredArrivalText.key}
            dictionaryDefaultValue={
              Dictionary.airFlightBookFlightsWhyChooseUsAssuredArrivalText.defaultValue
            }
            imgPath={renderContent(
              Dictionary.airBookFlightsWhyChooseUsAaImgPath.key,
              Dictionary.airBookFlightsWhyChooseUsAaImgPath.defaultValue,
            )}
          />
          <CardMui
            extraClass={classes.support}
            dictionaryKey={Dictionary.airFlightBookFlightsWhyChooseUsSupportText.key}
            dictionaryDefaultValue={
              Dictionary.airFlightBookFlightsWhyChooseUsSupportText.defaultValue
            }
            imgPath={renderContent(
              Dictionary.airBookFlightsWhyChooseUs247ImgPath.key,
              Dictionary.airBookFlightsWhyChooseUs247ImgPath.defaultValue,
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsRoyal;
